import React, { createContext, useContext } from "react";
import { useAlert, UseAlert } from "../hooks/useAlert";

const AlertContext = createContext<UseAlert | undefined>(undefined);

export const AlertProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const alert = useAlert();
  return (
    <AlertContext.Provider value={alert}>
      {children}
      {alert.AlertComponent}
    </AlertContext.Provider>
  );
};

export function useGlobalAlert() {
  const context = useContext(AlertContext);
  if (!context) throw new Error("useGlobalAlert debe usarse dentro de <AlertProvider>");
  return context;
}
